/* eslint-disable no-dupe-keys */
//App
import { ChangePasswordDto } from "../app/model/api/types/dto/changePasswordDto";

export class ChangePasswordViewModel {
  //userId: string | null;
  currentPassword: string | null;
  newPassword: string | null;
  confirmNewPassword: string | null;

  constructor(
    //userId: string | null,
    currentPassword: string | null,
    newPassword: string | null,
    confirmNewPassword: string | null
  ) {
    //this.userId = userId;
    this.currentPassword = currentPassword;
    this.newPassword = newPassword;
    this.confirmNewPassword = confirmNewPassword;
  }

  toDto(): ChangePasswordDto {
    return {
      //userId: this.userId,
      currentPassword: this.currentPassword,
      newPassword: this.newPassword,
      confirmNewPassword: this.confirmNewPassword,
    };
  }

  mapFromDto(dto: ChangePasswordDto): void {
    //this.userId = dto.userId;
    this.currentPassword = dto.currentPassword;
    this.newPassword = dto.newPassword;
    this.confirmNewPassword = dto.confirmNewPassword;
  }
}
